export default "__VITE_ASSET__SW7hm0Oi__"